document.addEventListener('DOMContentLoaded', function () {
  // Only enable hover-to-open on devices with a real mouse (not touch)
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const headerMenus = document.querySelectorAll('header-menu');

  headerMenus.forEach(function (menu) {
    const details = menu.querySelector('details');
    if (!details) return;

    let closeTimer;

    menu.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);

      // Close any other open mega menus first
      headerMenus.forEach(function (otherMenu) {
        if (otherMenu !== menu) {
          const otherDetails = otherMenu.querySelector('details');
          if (otherDetails && otherDetails.hasAttribute('open')) {
            otherDetails.removeAttribute('open');
          }
        }
      });

      details.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', function () {
      // Small delay so moving mouse from summary to content doesn't flicker-close it
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });

    // Prevent the native click-toggle from fighting with hover state on desktop
    const summary = details.querySelector('summary');
    summary.addEventListener('click', function (e) {
      e.preventDefault();
    });
  });
});